import React from 'react';
import { Link } from 'react-router-dom';

// Ruta comodín: antes una URL inexistente dejaba la página en blanco.
const NotFoundPage = () => (
  <section className="flex min-h-[60vh] items-center justify-center px-4 py-10">
    <div className="max-w-md rounded-3xl border border-slate-200/70 bg-white/90 p-8 text-center shadow-2xl dark:border-slate-700 dark:bg-slate-900/90">
      <p className="text-5xl font-extrabold text-blue-600 dark:text-blue-400">404</p>
      <h2 className="mt-2 text-xl font-bold text-slate-900 dark:text-slate-100">Página no encontrada</h2>
      <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">La dirección no existe o ha cambiado.</p>
      <Link to="/" className="mt-5 inline-block rounded-xl bg-blue-600 px-5 py-2.5 text-sm font-bold text-white hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-600">
        Volver al inicio
      </Link>
    </div>
  </section>
);

export default NotFoundPage;
